export default __webpack_public_path__ + "pgnv-assets/c1ec7c641d1689ec457f2891cb96b4e5.svg";